import * as React from 'react';
import PricePresentation, { IPricePresentationBase } from '../PricePresentation';
import { IPrice } from '@vp/vp-js-token-engine';

export default class RawPrice extends React.Component<IPricePresentationBase<IPrice>> {
  public render(): JSX.Element {
    return (
      <PricePresentation
        classNameWrapper={this.props.classNameWrapper}
        type="rawPrice"
        pricingInfo={this.props.pricingInfo}
        tenant={this.props.tenant}
        placeHolderText={this.props.placeHolderText}
        isTile={this.props.isTile}
      />
    );
  }
}
